import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteEstadosoDeInfraccion,
  getEstadosDeInfracciones,
  patchEstadosoDeInfraccion,
  postEstadosoDeInfraccion,
} from 'api/catalogos/estadosDeInfracciones';

// eslint-disable-next-line react/prop-types
const EstadoDeInfracciones = ({ permission }) => (
  <PlainCRUD
    title="Estado de infracción"
    permission={permission}
    get={getEstadosDeInfracciones}
    post={postEstadosoDeInfraccion}
    patch={patchEstadosoDeInfraccion}
    delete={deleteEstadosoDeInfraccion}
    withoutState
    fields={[
      defaultFields.descripcion,
    ]}
  />
);

export default EstadoDeInfracciones;
